import React from 'react';
import ReactDOM from 'react-dom';
import App from 'components/App/App';
import { store } from 'redux/store';
import { Provider } from 'react-redux';
import * as serviceWorker from 'serviceWorker';
import CalciteTheme from 'components/CalciteTheme';

import {
  applyPolyfills as applyCalciteComponentsPolyfills,
  defineCustomElements as defineCalciteComponentsCustomElements
} from '@esri/calcite-components/dist/loader';

import '@esri/calcite-components/dist/calcite/calcite.css';
import './index.css';
import { ThemeProvider } from 'styled-components';

/*
 * Defining all the custom calcite elements here saves us from having to define
 * the custom element imports each time we use a calcite component throughout
 * the codebase. The downside is that this prevents any tree shaking from
 * happening, which will increase the bundle size. In a small app like this
 * one, it shouldn't be too great of a concern.
 */
applyCalciteComponentsPolyfills().then(() => {
  defineCalciteComponentsCustomElements(window, {
    resourcesUrl: `${window.location.origin}${process.env.PUBLIC_URL}/calcite/`
  });
});

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={CalciteTheme}>
        <App />
      </ThemeProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
